import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { part } from "../../api";
import { Form, Modal } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import AddParts from "../../pages/parts_inventory/add";

export const PurchaseOrderItem = ({ readOnly, onChange, value }) => {
  const [tasks, setTasks] = useState(value);
  const [openChecklist, setOpenChecklist] = useState(false);
  const [openPartForm, setOpenPartForm] = useState(false);

  const { config } = useAuth();

  const [checklist, setChecklist] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState([]);
  const addTask = () => {
    let copy = [...tasks];
    copy = [...copy, { name: "", cost: 0, quantity: 1 }];
    setTasks(copy);
  };

  const handleTaskChange = (e, index) => {
    let copy = [...tasks];
    const key = e.target.name;
    copy[index][key] = e.target.value;
    setTasks(copy);
  };

  const deleteTask = (index) => {
    let copy = [...tasks];
    copy.splice(index, 1);
    setTasks(copy);
  };

  useEffect(() => {
    onChange(tasks);
  }, [tasks]);

  useEffect(() => {
    setTasks(value);
  }, [value]);

  const getChecklistTemplate = async () => {
    const result = await part.list({ company: true });
    if (result.ok) {
      const body = await result.json();
      setChecklist(body.data);
    }
  };

  const handleApplyChecklist = () => {
    if (selectedChecklist.length > 0) {
      const c = checklist.filter((c) => selectedChecklist.includes(c.id));
      let newTasks = [...tasks];
      c.map((c) => {
        newTasks = [
          ...newTasks,
          { name: c.part_name, cost: c.part_cost, quantity: 1 },
        ];
      });
      setTasks(newTasks);
      setOpenChecklist(false);
      setSelectedChecklist([]);
    }
  };

  const selectChecklist = (id) => {
    const copy = [...selectedChecklist];
    if (copy.includes(id)) {
      setSelectedChecklist(copy.filter((c) => c != id));
    } else {
      copy.push(id);
      setSelectedChecklist(copy);
    }
  };

  useEffect(() => {
    if (openChecklist) {
      getChecklistTemplate();
    }
  }, [openChecklist]);

  const handleOpenPartForm = () => {
    setOpenPartForm(true);
  };

  const handleClosePartForm = () => {
    setOpenPartForm(false);
  };

  const handleAfterSubmit = () => {
    getChecklistTemplate();
    handleClosePartForm();
  };
  return (
    <Card>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Line Items</div>
          {!readOnly && (
            <div>
              {/* <button
                onClick={addTask}
                className="btn btn-sm btn-outline-theme"
                style={{ marginRight: "10px" }}
              >
                Add Custom Item
              </button> */}

              <>
                <button
                  onClick={() => setOpenChecklist(true)}
                  className="btn btn-sm btn-outline-theme"
                  style={{ marginRight: "10px" }}
                >
                  Add Part
                </button>
                <ConfirmationDlg
                  type="submit"
                  onClose={() => setOpenChecklist(false)}
                  title={"Select Part"}
                  open={openChecklist}
                  onSubmit={handleApplyChecklist}
                >
                  <div className="mb-2">
                    Select Existing Part or{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={handleOpenPartForm}
                    >
                      Add New Part
                    </span>
                  </div>
                  <hr></hr>
                  {checklist.map((v) => {
                    return (
                      <Form.Check
                        key={v.id}
                        style={{ textTransform: "capitalize" }}
                        onChange={() => selectChecklist(v.id)}
                        type={"checkbox"}
                        label={v.part_name}
                        checked={selectedChecklist.includes(v.id)}
                      />
                    );
                  })}
                </ConfirmationDlg>

                <Modal
                  show={openPartForm}
                  size={"xl"}
                  onHide={handleClosePartForm}
                  onBackdropClick={handleClosePartForm}
                  centered
                >
                  <AddParts afterSubmitCallback={handleAfterSubmit} />
                </Modal>
              </>
            </div>
          )}
        </div>
      </CardHeader>
      <CardBody>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: ".5em 1em",
          }}
        >
          <thead>
            <tr>
              <th>Item</th>
              <th>Cost</th>
              <th>Quantity</th>
              <th>Total</th>
              {!readOnly && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {tasks.map((ts, indexTask) => (
              <tr key={indexTask}>
                <td style={{ verticalAlign: "top" }}>
                  <input
                    readOnly={readOnly}
                    className="form-control"
                    type="text"
                    name="name"
                    onChange={(e) => handleTaskChange(e, indexTask)}
                    value={ts.name}
                  />
                </td>
                <td style={{ verticalAlign: "top" }}>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        {config?.currency_symbol}
                      </div>
                    </div>
                    <input
                      readOnly={readOnly}
                      className="form-control"
                      type="number"
                      name="cost"
                      onChange={(e) => handleTaskChange(e, indexTask)}
                      value={ts.cost}
                    />
                  </div>
                </td>
                <td style={{ verticalAlign: "top" }}>
                  <input
                    readOnly={readOnly}
                    className="form-control"
                    type="number"
                    name="quantity"
                    onChange={(e) => handleTaskChange(e, indexTask)}
                    value={ts.quantity}
                  />
                </td>
                <td style={{ verticalAlign: "top" }}>
                  {config?.currency_symbol} {ts.cost * ts.quantity}
                </td>

                {!readOnly && (
                  <td style={{ verticalAlign: "top" }}>
                    <div
                      className="btn btn-danger"
                      onClick={() => {
                        deleteTask(indexTask);
                      }}
                    >
                      Delete
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
};
